const ExperienceList = [
    {
        "title": "Web Developer",
        "company": "CodeSpeedy Techology PVT LTD ",
        "startDate": "July 2024",
        "endDate": "Sep 2024",
        "location": "Work from home",
        "points": [
            "Developed a web application that allows users to resize an image using React.js, HTML, CSS3 and Java Script. Created the Job Portal Application where an admin add thejobs using admin portal and job seeker apply to it fully functional website using MERN. Authored a detailed blog post documenting the development process, challenges faced, and solutions implemented for the above tasks, shared insights and best practices with the development community on the company portal",
            
        ]
    },
   
   
    {
        "title": "Web Developer",
        "company": "Suvidha Foundation",
        "startDate": "Feb 2024",
        "endDate": "Mar 2024",
        "location": "Remote",
        "points": [
            "Devloped a full stack job portal using MERN stack enabling userauthentication , job listing and application testing"
        
        ]
    },
];

export default ExperienceList;
